import React from "react";
import { SvgIcon } from "@mui/material";
import styles from "../../icons/iconStyles";

const WebsiteIcon = ({ color }: any) => {
  return (
    <SvgIcon style={styles.icon}>
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_6201_33479)">
          <path
            d="M9.99739 1.66602C12.4974 3.33268 13.2664 6.90938 13.3307 9.99935C13.2664 13.0893 12.4974 16.666 9.9974 18.3327M9.99739 1.66602C7.4974 3.33268 6.72844 6.90938 6.66406 9.99935C6.72844 13.0893 7.4974 16.666 9.9974 18.3327M9.99739 1.66602C5.39502 1.66602 1.66406 5.39698 1.66406 9.99935M9.99739 1.66602C14.5998 1.66602 18.3307 5.39698 18.3307 9.99935M9.9974 18.3327C14.5998 18.3327 18.3307 14.6017 18.3307 9.99935M9.9974 18.3327C5.39503 18.3327 1.66406 14.6017 1.66406 9.99935M18.3307 9.99935C16.6641 12.4993 13.0874 13.2683 9.9974 13.3327C6.90742 13.2683 3.33073 12.4993 1.66406 9.99935M18.3307 9.99935C16.6641 7.49935 13.0874 6.73039 9.9974 6.66602C6.90742 6.73039 3.33073 7.49935 1.66406 9.99935"
            stroke="#C7C9CD"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_6201_33479">
            <rect width="20" height="20" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </SvgIcon>
  );
};

export default WebsiteIcon;
